import { PropsWithChildren } from 'react';

import SkipToMain from '@/components/accessibility/SkipToMain';
import ClientProviders from '@/components/layout/ClientProviders';
import Devtools from '@/components/layout/Devtools';
import LayoutScripts from '@/components/layout/LayoutScripts';
import RecaptchaModal from '@/components/layout/RecaptchaModal';
import ToastNotification from '@/components/ui/ToastNotification';

const PageWrapper = ({
	customMainId,
	hideAcceptCookiesModal,
	analyticsPageName,
	locale,
	messages,
	children,
}: PropsWithChildren<{
	customMainId?: string;
	hideAcceptCookiesModal?: boolean;
	analyticsPageName?: string;
	locale?: string;
	messages?: Record<string, string>;
}>) => {
	return (
		<ClientProviders
			hideAcceptCookiesModal={hideAcceptCookiesModal}
			analyticsPageName={analyticsPageName}
			locale={locale}
			messages={messages}
		>
			<LayoutScripts />
			<SkipToMain href={customMainId} />
			{children}
			<Devtools />
			<RecaptchaModal />
			<ToastNotification />
		</ClientProviders>
	);
};

export default PageWrapper;
